import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI } from '../../../app/api';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import InputGroupHandler from '../../../UIComponents/InputGroupHandler';
import Loader from '../../../UIComponents/Loader';
import { useParams } from 'react-router-dom';

export default function Form({ Page = "", is_edit = 0, edit_id = 0 }) {
    const { exam_id } = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [FormData, setFormData] = useState({ exam_id: exam_id, is_mcq: "1" });
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async id => {
        const response = await postAPI("/questions/fetchSingle", { id, user: store_data });
        const data = response?.data?.length > 0 ? response?.data[0] : null;
        if (response?.status === 1 && data) {
            setFormData({
                id: data?.id,
                exam_id: data?.exam_id || exam_id,
                is_mcq: String(data?.is_mcq ?? "1"),
                question: data?.question || "",
                hint: data?.hint || "",
                answer: data?.answer || "",
                option1: data?.option1 || "",
                option2: data?.option2 || "",
                option3: data?.option3 || "",
                option4: data?.option4 || "",
            });
        } else {
            toast.error('Unable to load question details for edit.');
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("EXAM", "Questions", "CREATE");
                const editAllowed = await hasPermission("EXAM", "Questions", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };

        const init = async () => {
            await checkPermissions();
            if (is_edit && edit_id) {
                await fetchSingleData(edit_id);
            } else {
                setFormData({ exam_id: exam_id, is_mcq: "1" });
            }
            setLoading(false);
        };

        init();
    }, [is_edit, edit_id]);

    const validate = () => {
        let errors = [];
        if (!FormData.question) errors.push('Question is required.');
        if (Number(FormData.is_mcq) === 1) {
            if (!FormData.option1) errors.push('Option A is required.');
            if (!FormData.option2) errors.push('Option B is required.');
            if (!FormData.option3) errors.push('Option C is required.');
            if (!FormData.option4) errors.push('Option D is required.');
            if (!FormData.answer) errors.push('Answer is required.');
        }
        setError(errors);
        return errors.length === 0;
    };

    const handleSubmit = async () => {
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            return;
        }
        if (IsBTNClicked) return;
        if (!validate()) {
            toast.error('Please fix validation errors.');
            return;
        }
        setIsBTNClicked(true);
        const payload = { org_id: store_data?.org_id, ...FormData };
        const response = await postAPI(is_edit ? "/questions/update" : "/questions/create", {...payload, user: store_data});
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('Question saved successfully.');
            window.location.reload();
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {Loading ? <Loader /> :
                (!isAdmin() && !canCreate && !canEdit) ? (
                    <div className="alert alert-danger">You do not have permission to access this form.</div>
                ) : (
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        {/* <div className="col-12 col-md-6">
                            <SelectBoxHandler Label="Is MCQ" Options={[{ label: "Yes", value: "1" }, { label: "No", value: "0" }]} Name="is_mcq" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                        </div> */}
                        <div className="col-12 col-md-12">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="question" Type="text" Label="Question" />
                        </div>
                        <div className="col-12 col-md-12">
                            <NormalTextareaHandler form_data={FormData} setFormData={setFormData} Name="hint" Type="text" Label="Hint" />
                        </div>
                        {Number(FormData?.is_mcq) === 1 ? (
                            <>
                                <div className="col-6 col-md-6">
                                    <InputGroupHandler RadioName="answer" RadioValue="option1" form_data={FormData} setFormData={setFormData} Name="option1" Type="text" Label="Option A" />
                                </div>
                                <div className="col-6 col-md-6">
                                    <InputGroupHandler RadioName="answer" RadioValue="option2" form_data={FormData} setFormData={setFormData} Name="option2" Type="text" Label="Option B" />
                                </div>
                                <div className="col-6 col-md-6">
                                    <InputGroupHandler RadioName="answer" RadioValue="option3" form_data={FormData} setFormData={setFormData} Name="option3" Type="text" Label="Option C" />
                                </div>
                                <div className="col-6 col-md-6">
                                    <InputGroupHandler RadioName="answer" RadioValue="option4" form_data={FormData} setFormData={setFormData} Name="option4" Type="text" Label="Option D" />
                                </div>
                            </>
                        ) : null}
                        {Error.length > 0 && (
                            <div className="alert alert-danger">
                                <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                            </div>
                        )}
                    </FormSubmissionHandler>
                )
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
